"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoundary = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
var GroupContext_1 = require("../input/GroupContext");
function renderInfo(infos, value, prefixCls) {
    for (var i = 0; i < infos.length; i++) {
        var info = infos[i].content;
        var cls = infos[i].extraCls;
        if (!info) {
            continue;
        }
        if (typeof info === 'boolean') {
            return null;
        }
        if (typeof info === 'function') {
            return info(value);
        }
        if (typeof info === 'string') {
            return react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(prefixCls, "-form-item-explain"), cls) }, info);
        }
        return info;
    }
    return null;
}
function InfoBoundary(WrappedComponent, defaultProps) {
    var Cp = WrappedComponent;
    var displayName = Cp.displayName || Cp.name || 'Component';
    var ComponentWithInfo = (0, react_1.forwardRef)(function (_a, ref) {
        var _b;
        var info = _a.info, error = _a.error, warning = _a.warning, _c = _a.Component, Component = _c === void 0 ? 'div' : _c, restProps = tslib_1.__rest(_a, ["info", "error", "warning", "Component"]);
        var inGroup = (0, GroupContext_1.useGroup)().inGroup;
        var _d = tslib_1.__assign(tslib_1.__assign({}, defaultProps), restProps), value = _d.value, style = _d.style, className = _d.className, cpProps = tslib_1.__rest(_d, ["value", "style", "className"]);
        var hasValue = value !== null && value !== undefined;
        var getPrefixCls = (0, react_1.useContext)(config_provider_1.ConfigContext).getPrefixCls;
        var prefixCls = getPrefixCls();
        var infoElement = renderInfo([
            {
                content: error,
                extraCls: "".concat(prefixCls, "-form-item-explain-error"),
            },
            {
                content: warning,
                extraCls: "".concat(prefixCls, "-form-item-explain-warning"),
            },
            {
                content: info,
            },
        ], value, prefixCls);
        if (inGroup) {
            return (react_1.default.createElement(WrappedComponent, tslib_1.__assign({ style: style, className: className }, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, cpProps), (hasValue ? { value: value } : {})), (ref ? { ref: ref } : {})))));
        }
        return (react_1.default.createElement(Component, tslib_1.__assign({}, defaultProps, { style: style, className: (0, classnames_1.default)(className, (_b = {},
                _b["".concat(prefixCls, "-form-item-has-error")] = error,
                _b["".concat(prefixCls, "-form-item-has-warning")] = warning,
                _b)) }),
            react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, cpProps), (hasValue ? { value: value } : {})), (ref ? { ref: ref } : {})))),
            infoElement));
    });
    ComponentWithInfo.displayName = "withInfo(".concat(displayName, ")");
    return ComponentWithInfo;
}
exports.InfoBoundary = InfoBoundary;
exports.default = InfoBoundary;
//# sourceMappingURL=index.js.map